// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1g3Nx","question":"styles_question__Fd_TO","inputVisibleButton":"styles_inputVisibleButton__d9hVA","note":"styles_note__2LBJX"};